import {
  ActionBarContainer,
  ActionBarHeaderTextContainer,
  ActionBarStickyContainer,
} from "./styled";
import BarekamButton, { ActionbarButtons, SimpleButtons } from "../button";
import BarekamText from "../text";
import { useNavigate } from "react-router-dom";
import { BarekamIcon, IconVariants } from "../icon/barekam-icon";
import React, { MutableRefObject, useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/store";
import { Message, MessageSections } from "../message/message";
import arrow from "../../../assets/icons/arrow.svg";
import { Menu } from "@mui/material";
import { ActionBarActions } from "../../../management-pages/actions/action-buttons";
import {
  GenericActionTypes,
  InWarehouseActionTypes,
  OrderPopupActionTypes,
  ReadyForShipmentActionTypes,
} from "../../../management-pages/actions/action-types.enum";

export const ActionBar = ({
  sticky,
  withBackButton,
  headerText,
  buttonText,
  buttonFunction,
  actions,
  actionFunction,
  mainContentContainerRef,
  customComponent,
  overallItems,
}: ActionBarProps) => {
  const { matchesPhone } = useAppSelector((state) => state.deviceReducer);

  const [stickied, setStickied] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (sticky) {
      if (mainContentContainerRef && mainContentContainerRef.current) {
        mainContentContainerRef.current.addEventListener(
          "scroll",
          checkStickiness,
        );
      }

      return () => {
        if (mainContentContainerRef && mainContentContainerRef.current) {
          mainContentContainerRef.current.removeEventListener(
            "scroll",
            checkStickiness,
          );
        }
      };
    }
  }, [mainContentContainerRef]);

  function checkStickiness() {
    const scrollTop =
      mainContentContainerRef && mainContentContainerRef.current
        ? mainContentContainerRef.current.scrollTop
        : 0;
    setStickied(scrollTop >= 14);
  }

  const ActionBarContent = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const actionMenuOpened = Boolean(anchorEl);

    function openActionMenu(event: React.MouseEvent<HTMLButtonElement>) {
      setAnchorEl(event.currentTarget || null);
    }

    function onActionFunctionClick(
      actionId:
        | InWarehouseActionTypes
        | ReadyForShipmentActionTypes
        | OrderPopupActionTypes
        | GenericActionTypes,
    ) {
      if (actionFunction) {
        setAnchorEl(null);

        actionFunction(actionId);
      }
    }

    return (
      <>
        <ActionBarHeaderTextContainer>
          {withBackButton ? (
            <BarekamButton
              type={SimpleButtons.LINK}
              onClick={() => navigate(-1)}
            >
              <BarekamIcon variant={IconVariants.back} />
            </BarekamButton>
          ) : (
            ""
          )}

          {headerText ? (
            <BarekamText variant={"xxl"} bold>
              {headerText} {overallItems && `(${overallItems})`}
            </BarekamText>
          ) : (
            <div />
          )}
        </ActionBarHeaderTextContainer>

        {actions && actions.length ? (
          <>
            <BarekamButton
              type={ActionbarButtons.NEW}
              onClick={(event) => openActionMenu(event)}
            >
              <BarekamText variant={"header"} bold>
                <Message
                  messageKey={"actions"}
                  sectionId={MessageSections.MAIN}
                />
              </BarekamText>

              <img src={arrow} alt={"arrow"} />
            </BarekamButton>

            <Menu
              open={actionMenuOpened}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
            >
              <ActionBarActions
                actions={actions}
                onClick={(actionId) => onActionFunctionClick(actionId)}
              />
            </Menu>
          </>
        ) : (
          ""
        )}

        {buttonText ? (
          <BarekamButton
            type={ActionbarButtons.NEW}
            sx={{ width: matchesPhone ? "100%" : "max-content" }}
            size={"m"}
            onClick={() => buttonFunction && buttonFunction()}
          >
            {buttonText}
          </BarekamButton>
        ) : (
          ""
        )}

        {customComponent || ""}
      </>
    );
  };

  return (
    <>
      {sticky ? (
        <ActionBarStickyContainer
          style={{
            boxShadow: stickied
              ? "0px 15px 10px -15px rgba(69, 77, 102, 0.30)"
              : "unset",
            flexDirection: matchesPhone ? "column" : "row",
            padding: matchesPhone ? "1rem" : "unset",
          }}
        >
          <ActionBarContent />
        </ActionBarStickyContainer>
      ) : (
        <ActionBarContainer
          style={{
            flexDirection: matchesPhone ? "column" : "row",
            padding: matchesPhone ? "1rem" : "unset",
          }}
        >
          <ActionBarContent />
        </ActionBarContainer>
      )}
    </>
  );
};

export interface ActionBarProps {
  sticky?: boolean;
  withBackButton?: boolean;
  overallItems?: number;
  headerText?: React.ReactElement;
  buttonText?: React.ReactElement;
  // eslint-disable-next-line @typescript-eslint/ban-types
  buttonFunction?: Function;

  actions?: any[];
  actionFunction?: (actionId: string) => void;

  mainContainerProps?: HTMLElement;
  mainContentContainerRef?: MutableRefObject<HTMLElement | null>;
  customComponent?: React.ReactElement;
}
